module.exports = __webpack_public_path__ + "static/img/default-cover.0273638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/oem/reolink-cn/cloud/default-cover.jpg
// module id = HSxj
// module chunks = 2